// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2bzWQ","topBottomGutter":"Layout_topBottomGutter__18N2a"};